import {
  ComponentType,
  createContext,
  FC,
  PropsWithChildren as IProps,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

import { IDrawerContext } from './types';

const drawerContext = createContext<IDrawerContext>({
  isDrawerOpened: false,
  openDrawerHandler: () => {},
  closeDrawerHandler: () => {},
});

export const useDrawerState = () => useContext(drawerContext);

export const DrawerStateProvider: FC<IProps> = ({ children }) => {
  const [isDrawerOpened, setIsDrawerOpened] = useState(false);

  const openDrawer = useCallback(() => setIsDrawerOpened(true), []);
  const closeDrawer = useCallback(() => setIsDrawerOpened(false), []);

  const drawerContextValue = useMemo(
    () => ({
      isDrawerOpened,
      openDrawerHandler: openDrawer,
      closeDrawerHandler: closeDrawer,
    }),
    [isDrawerOpened, openDrawer, closeDrawer],
  );

  return <drawerContext.Provider value={drawerContextValue}>{children}</drawerContext.Provider>;
};

export const withDrawerStateProvider = <P extends object>(Component: ComponentType<P>) => {
  const WithDrawerStateProvider: FC<P> = (props) => {
    return (
      <DrawerStateProvider>
        <Component {...props} />
      </DrawerStateProvider>
    );
  };

  return WithDrawerStateProvider;
};
